
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Fiftythreeseater() {



    const cardData =
    {
        keyword: '53 Seater Volvo Bus Hire Pune',
        heading: 'Amruta Travels: 53 Seater Volvo Bus Hire Pune',
        headingDescription: 'Amruta Travels offers 53 Seater Volvo Bus Hire in Pune, perfect for large group travel with unmatched luxury and convenience. Whether you are planning a corporate retreat, wedding guest transport, pilgrimage, or school tour, our 53-seater Volvo buses ensure a smooth and premium ride. Featuring reclining seats, powerful air-conditioning, ample legroom, and top-tier suspension, every journey becomes a relaxed and enjoyable experience. With professional drivers, on-time service, and 24/7 support, Amruta Travels is your trusted partner for luxury group travel in and around Pune.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',


  "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Located around 120 km from Pune, Mahabaleshwar is a picturesque hill station in the Western Ghats, known for its cool climate, evergreen forests, and stunning viewpoints such as Arthur’s Seat, Wilson Point (the highest point), and Kate's Point. The region is famous for its strawberry farms, especially during the Strawberry Festival held in spring. Other attractions include Venna Lake for boating, Mapro Garden for strawberry-based treats, and ancient temples like Panchganga and Mahabaleshwar Temple. It's a popular destination for families, honeymooners, and nature enthusiasts seeking a refreshing escape from city life."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range offer a perfect blend of natural beauty and adventure. Lonavala is known for its misty mountains, lush greenery, and monsoon waterfalls like Kune and Bhivpuri. Attractions include Bhushi Dam, Tiger’s Leap, Rajmachi Fort, and Karla & Bhaja Caves. Khandala is equally famous for its panoramic valley views and trekking routes. The area is ideal for a weekend drive, with scenic routes and roadside chikki stalls that add to the charm of this quick getaway."
    },
    {
      "title": "Shirdi",
      "description": "About 190 km from Pune, Shirdi is a sacred town revered by followers of Sai Baba. The Sai Baba Samadhi Mandir is the main attraction, drawing millions of devotees every year. Pilgrims can also visit Dwarkamai, Chavadi, and the Sai Heritage Village. The spiritual ambiance, combined with well-maintained infrastructure and religious events, makes Shirdi a prominent destination for those seeking peace, healing, and spiritual growth."
    },
    {
      "title": "Goa",
      "description": "Located nearly 450 km from Pune, Goa is India’s premier beach destination, known for its lively culture, golden beaches, and Portuguese heritage. From North Goa’s party hotspots like Baga, Anjuna, and Calangute to South Goa’s serene stretches like Palolem and Colva, there’s a vibe for every traveler. Apart from beaches, visitors can explore Aguada Fort, Basilica of Bom Jesus, spice plantations, vibrant flea markets, and indulge in thrilling water sports. Goa is also a haven for foodies, offering authentic seafood, Goan curries, and beachside shacks serving refreshing cocktails."
    },
    {
      "title": "Nashik",
      "description": "Around 210 km from Pune, Nashik is a city of immense cultural, historical, and spiritual significance. It is one of the four cities where the Kumbh Mela is held. Attractions include the ancient Kalaram Temple, Muktidham Temple, Pandavleni Caves, and Trimbakeshwar Temple—an important Jyotirlinga. Nashik is also the wine capital of India, home to Sula Vineyards, York Winery, and many tasting tours. The Godavari River adds to its charm, making it a harmonious blend of spirituality and leisure tourism."
    },
    {
      "title": "Alibaug",
      "description": "Situated about 140 km from Pune, Alibaug is a tranquil coastal town offering a perfect mix of beaches, history, and nature. Popular beaches include Nagaon, Alibaug Beach, and Kashid Beach, all great for swimming, sunbathing, and water sports. The iconic Kolaba Fort, accessible during low tide, adds historical value to the destination. You can also explore Korlai Fort, Kanakeshwar Temple, and local seafood cuisine. Ideal for weekend trips, Alibaug also offers ferry services from Mumbai for added convenience."
    },
    {
      "title": "Kolhapur",
      "description": "Roughly 235 km from Pune, Kolhapur is a vibrant city known for its divine Mahalaxmi Temple, which draws pilgrims throughout the year. The city is equally famous for its spicy cuisine, Kolhapuri chappals, and traditional arts. Attractions include Rankala Lake for evening strolls, Panhala Fort offering panoramic views, and the New Palace Museum showcasing royal heritage. With its rich cultural identity and warm hospitality, Kolhapur is ideal for heritage and culinary tourism."
    },
    {
      "title": "Lavasa",
      "description": "Just 60 km from Pune, Lavasa is an Italian-inspired planned city nestled in the Sahyadri hills. It features beautiful waterfronts, European-style architecture, and a peaceful atmosphere perfect for a quick weekend escape. Activities include kayaking, zip-lining, and lakeside cycling. With cozy resorts, conference centers, and nature trails, Lavasa attracts both families and corporate travelers. The weather remains pleasant most of the year, enhancing its appeal as a rejuvenating destination close to Pune."
    },
    {
      "title": "Satara & Kaas Plateau",
      "description": "About 120 km from Pune, Satara serves as the base for exploring the Kaas Plateau—popularly known as the 'Valley of Flowers' of Maharashtra. The plateau, a UNESCO World Natural Heritage site, bursts into a riot of colors with over 850 species of wildflowers during the monsoon season. Satara is also known for Ajinkyatara Fort, Thoseghar Waterfalls, and Sajjangad Fort. The natural beauty and biodiversity make this region a paradise for trekkers, botanists, and photographers."
    },
    {
      "title": "Aurangabad",
      "description": "Situated 235 km from Pune, Aurangabad is a historical treasure trove, offering insights into ancient art, architecture, and culture. The city is home to the world-famous Ajanta and Ellora Caves, adorned with exquisite carvings and paintings dating back to 2nd century BCE. Other attractions include Bibi Ka Maqbara (a replica of the Taj Mahal), Daulatabad Fort, and Aurangabad Caves. The city is also a gateway to Grishneshwar Jyotirlinga and Paithani saree shopping, making it a must-visit for heritage lovers."
    }
  ],

     "services": [
    {
      "name": "53 Seater Volvo Bus on Rent in Pune",
      "description": "Rent a 53 Seater Volvo bus in Pune for your group travel needs. Perfect for large groups, whether it's for a corporate trip, wedding, or family outing. Our Volvo buses ensure comfort, luxury, and a smooth ride with air conditioning and ample seating for a relaxed journey."
    },
    {
      "name": "AC 53 Seater Volvo Bus Rental Pune",
      "description": "Our AC 53 Seater Volvo buses are available for rent in Pune, providing a luxurious travel experience. With high-end features such as reclining seats, air conditioning, and ample luggage space, these buses are perfect for long-distance journeys, weddings, and corporate events."
    },
    {
      "name": "Luxury Volvo Bus Hire for Outstation",
      "description": "Travel in style with our luxury Volvo buses for outstation trips. Whether you're heading to a distant destination for a corporate event or a wedding, our 53 Seater Volvo buses offer a premium travel experience, ensuring comfort and safety for all passengers."
    },
    {
      "name": "Wedding Volvo Bus on Rent",
      "description": "Make your wedding transportation unforgettable with our 53 Seater Volvo buses. Our luxury buses provide a comfortable and stylish ride for guests, ensuring everyone arrives at the venue in comfort and luxury. Perfect for large wedding parties and functions."
    },
    {
      "name": "Corporate 53 Seater Bus Booking Pune",
      "description": "Book a 53 Seater Volvo bus for your next corporate event in Pune. Our buses are equipped with all modern amenities to ensure your team travels in comfort and style, whether it's for a conference, seminar, or corporate trip."
    },
    {
      "name": "Volvo Bus for School Trips in Pune",
      "description": "Our 53 Seater Volvo buses are ideal for school trips in Pune. With comfortable seating, air conditioning, and safety features, these buses provide a secure and enjoyable journey for students and teachers, ensuring a hassle-free experience."
    },
    {
      "name": "53 Seater Volvo Coach for Religious Tour",
      "description": "Embark on a religious journey with our 53 Seater Volvo coach. Whether visiting temples, pilgrimages, or religious festivals, our buses provide comfort, safety, and ample space for passengers, making your spiritual trip a pleasant and memorable experience."
    },
    {
      "name": "Volvo Bus for Marriage Functions Pune",
      "description": "Rent our 53 Seater Volvo buses for wedding functions in Pune. These buses are the perfect choice for transporting guests in style, with plush seating, air conditioning, and ample space for a comfortable ride to and from the venue."
    },
    {
      "name": "Volvo 53 Seater Bus Hire in Kothrud",
      "description": "We offer Volvo 53 Seater buses for hire in Kothrud, Pune, for your group travel needs. Perfect for corporate events, weddings, school trips, and long-distance journeys, these buses ensure comfort, reliability, and luxury."
    },
    {
      "name": "Pune to Shirdi Volvo 53 Seater Bus",
      "description": "Book a Volvo 53 Seater bus for your trip from Pune to Shirdi. With comfortable seating, air conditioning, and professional drivers, our Volvo buses ensure a smooth and enjoyable pilgrimage journey to this sacred destination."
    },
    {
      "name": "53 Seater Volvo Bus Booking Hadapsar",
      "description": "Rent a 53 Seater Volvo bus in Hadapsar for your next event or group trip. Whether it’s for a corporate outing, wedding, or religious tour, our buses offer the luxury and comfort you deserve for a long-distance or local journey."
    },
    {
      "name": "Luxury Volvo Rental for Events Pune",
      "description": "Make your next event memorable with our luxury Volvo rental services in Pune. Our 53 Seater Volvo buses are perfect for conferences, weddings, corporate events, and group tours, offering modern amenities and a luxurious travel experience."
    },
    {
      "name": "Pune to Goa 53 Seater Bus Hire",
      "description": "Travel from Pune to Goa in comfort with our 53 Seater Volvo bus. Whether it’s for a corporate retreat, family trip, or friends' vacation, our buses offer a spacious and luxurious ride with air conditioning, reclining seats, and onboard amenities."
    },
    {
      "name": "Pune to Nashik Volvo Bus Booking",
      "description": "Book a 53 Seater Volvo bus for your trip from Pune to Nashik. Our buses offer luxurious comfort and are perfect for group travel, whether it’s for a pilgrimage, corporate event, or family outing. Enjoy a smooth and comfortable journey with us."
    },
    {
      "name": "Affordable 53 Seater Volvo Bus Service Pune",
      "description": "Looking for an affordable yet luxurious travel option? Rent our 53 Seater Volvo bus in Pune. Offering a premium travel experience with air conditioning, spacious seating, and modern amenities, our buses are perfect for any event or group tour."
    }
  ],
  "tableData": [
    ["53 Seater Volvo Bus on Rent in Pune", "AC 53 Seater Volvo Bus Rental Pune"],
    ["Luxury Volvo Bus Hire for Outstation", "Wedding Volvo Bus on Rent"],
    ["Corporate 53 Seater Bus Booking Pune", "Volvo Bus for School Trips in Pune"],
    ["53 Seater Volvo Coach for Religious Tour", "Volvo Bus for Marriage Functions Pune"],
    ["Volvo 53 Seater Bus Hire in Kothrud", "Pune to Shirdi Volvo 53 Seater Bus"],
    ["53 Seater Volvo Bus Booking Hadapsar", "Luxury Volvo Rental for Events Pune"],
    ["Pune to Goa 53 Seater Bus Hire", "Pune to Nashik Volvo Bus Booking"],
    ["Affordable 53 Seater Volvo Bus Service Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "53 Seater Volvo Bus on Hire in Pune",
    "WhyChoosedescription": "Amruta Travels offers the premium 53 Seater Volvo buses for hire in Pune, designed for large group travel. Whether it’s a corporate outing, school tour, or a wedding, our Volvo buses ensure that your group travels in style, comfort, and safety."
  },
  {
    "WhyChooseheading": "Spacious, Comfortable, and Air-Conditioned Travel",
    "WhyChoosedescription": "Our 53 Seater Volvo buses are equipped with superior air-conditioning, ergonomic seating, and ample legroom. Ideal for long-distance journeys, they offer a smooth and comfortable ride for large groups, ensuring a pleasant experience throughout the trip."
  },
  {
    "WhyChooseheading": "World-Class Amenities for a Superior Experience",
    "WhyChoosedescription": "The buses are equipped with high-end features, including luxurious reclining seats, efficient air conditioning, onboard entertainment, and wide windows for scenic views. Every journey is designed to offer maximum comfort and relaxation for all passengers."
  },
  {
    "WhyChooseheading": "Affordable, Transparent, and All-Inclusive Pricing",
    "WhyChoosedescription": "We offer clear and competitive pricing for 53 Seater Volvo bus rentals. Our all-inclusive rates cover fuel, tolls, driver allowances, taxes, and more—ensuring no hidden fees or surprises and making it easier for you to plan your trip budget."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers for Safe Travel",
    "WhyChoosedescription": "Our drivers are licensed, experienced, and well-versed in Pune’s local routes and outstation destinations. They prioritize passenger safety, punctuality, and customer service, ensuring a smooth and worry-free journey."
  },
  {
    "WhyChooseheading": "Perfect for Corporate Outings, Group Tours, and Weddings",
    "WhyChoosedescription": "The 53 Seater Volvo bus is ideal for large group events such as corporate outings, educational tours, family vacations, and weddings. With its capacity and comfort, it ensures your group travels together effortlessly, without compromising on luxury."
  },
  {
    "WhyChooseheading": "Regularly Maintained and Safe Fleet",
    "WhyChoosedescription": "Our fleet of 53 Seater Volvo buses undergoes regular maintenance and safety checks to ensure that each bus is in perfect condition. This guarantees a smooth, safe, and trouble-free journey for all passengers."
  },
  {
    "WhyChooseheading": "Easy Booking Process with 24/7 Customer Support",
    "WhyChoosedescription": "Booking your 53 Seater Volvo bus with Amruta Travels is quick and convenient. You can book online, by phone, or visit our office. Our 24/7 customer support team is always ready to assist with bookings, inquiries, and special requests."
  }
]


















    }

const faqData = [
  {
    question: 'Can I rent a 53-seater Volvo bus in Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers 53-seater Volvo buses for rent in Pune. These buses are ideal for large groups, providing a comfortable, safe, and luxurious travel experience for corporate trips, family outings, school tours, and long-distance travel.',
  },
  {
    question: 'What amenities are available in the 53-seater Volvo bus?',
    answer: 'Our 53-seater Volvo buses are equipped with premium features such as plush seating, air conditioning, modern entertainment systems, ample luggage space, clean and well-maintained interiors, and sufficient legroom for a luxurious and relaxing journey.',
  },
  {
    question: 'Is the 53-seater Volvo bus available for both local and outstation travel?',
    answer: 'Yes, the 53-seater Volvo bus is available for local city travel in Pune as well as outstation trips to popular destinations like Lonavala, Mahabaleshwar, Shirdi, Mumbai, and beyond.',
  },
  {
    question: 'Is a driver included in the 53-seater Volvo bus rental?',
    answer: 'Yes, all 53-seater Volvo bus rentals from Amruta Travels include an experienced and licensed driver who ensures safe, comfortable, and punctual travel for all passengers.',
  },
  {
    question: 'How much does it cost to rent a 53-seater Volvo bus in Pune?',
    answer: 'Rental charges for the 53-seater Volvo bus depend on factors like trip duration, distance, and additional services. Typically, rates start from ₹70-₹85 per km. Contact us for a customized quote based on your itinerary.',
  },
  {
    question: 'Is the 53-seater Volvo bus comfortable for long journeys?',
    answer: 'Yes, the 53-seater Volvo bus is designed for long-distance travel, offering luxurious seating, air conditioning, and ample space for passengers, ensuring a comfortable and relaxing journey for extended trips.',
  },
  {
    question: 'Are the 53-seater Volvo buses well-maintained and sanitized?',
    answer: 'Absolutely. All our 53-seater Volvo buses are regularly inspected, thoroughly cleaned, and sanitized before every trip to maintain the highest standards of hygiene and passenger safety.',
  },
  {
    question: 'How do I book a 53-seater Volvo bus in Pune?',
    answer: 'Booking a 53-seater Volvo bus is easy! You can book online through our website or get in touch with our customer support team for assistance. We offer hassle-free booking and competitive pricing.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Prakash Joshi',
    role: 'Business Owner, Pune',
    text: 'We hired a 53-seater Volvo bus from Amruta Travels for a corporate event. The bus was comfortable, spacious, and well-maintained. The service was excellent, and we had a very smooth ride.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Sunita Reddy',
    role: 'Tour Planner',
    text: 'I booked a 53-seater Volvo bus for a large group of tourists traveling to Mahabaleshwar. The bus was luxurious, and the passengers had a very comfortable journey. Amruta Travels provided impeccable service!',
    rating: 5,
  },
];



























































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "53 Seater Volvo Bus Hire in Pune",
  "image": "https://bushireinpune.com/assets/images/53-seater-volvo-bus.jpg",
  "description": "Amruta Travels offers 53 Seater Volvo Bus Hire in Pune for weddings, corporate events, religious tours, and outstation travel to Goa, Shirdi, or Nashik. Our air-conditioned Volvo coaches provide luxury, safety, and comfort for school trips, family tours, and large group events from Kothrud, Hadapsar, and all across Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "13100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8200",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/53-seater-volvo-bus-hire-pune"
  }
};







    return (
        <div>



<Helmet>
  <title>Call: +91 7353109555 | 53 Seater Volvo Bus Hire in Pune | Luxury AC Coach for Wedding & Outstation Trips</title>
  <meta 
    name="description" 
    content="Hire a 53 seater Volvo bus in Pune for weddings, corporate travel, school trips, and outstation tours to Shirdi, Goa, or Nashik. Book luxury AC Volvo coach rental with driver from Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/95.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Fiftythreeseater;